import { render, staticRenderFns } from "./index.vue?vue&type=template&id=218e375c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=218e375c&lang=css"
import style1 from "./index.vue?vue&type=style&index=1&id=218e375c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218e375c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('218e375c')) {
      api.createRecord('218e375c', component.options)
    } else {
      api.reload('218e375c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=218e375c&scoped=true", function () {
      api.rerender('218e375c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/designCategory/components/SimpleFormPage/index.vue"
export default component.exports